import React from "react";
import LoginWithUserIdandPassword from "./LoginWithUserIdandPassword/LoginWithUserIdandPassword";
import LoginWithEmailOrMobile from "./LoginWithEmailOrMobile/LoginWithEmailOrMobile";
import Login from "../../common/Login/Login";

const AgentLogin: React.FC = () => {
  const loginOptions = [
    {
      featureCode: "agent_email_mobile_login",
      featureLabel: "Email/Mobile",
    },
    {
      featureCode: "agent_userid_password_login",
      featureLabel: "User Id & Password",
    },
  ];

  const renderLoginForm = (loginType: string) => {
    switch (loginType) {
      case "agent_email_mobile_login":
        return <LoginWithEmailOrMobile isFunctionable={false} />;
      case "agent_userid_password_login":
        return <LoginWithUserIdandPassword />;
      default:
        return null;
    }
  };

  return (
    <Login
      loginOptions={loginOptions}
      defaultLoginType="agent_userid_password_login"
      showLanguageSelector={false}
      renderLoginForm={renderLoginForm}
      isCustomer={false}
    />
  );
};

export default AgentLogin;
